<div
    class="relative flex min-h-screen w-full items-center justify-center p-4 py-8 sm:p-6 lg:p-10"
    style="
        background: linear-gradient(
            180deg,
            #f8fafc 0%,
            #eef1f6 50%,
            #e9eef5 100%
        );
    "
>
    <!-- Centered Max-Width Container in Middle of Screen -->
    <div
        class="mx-auto flex w-full max-w-6xl items-center justify-between gap-8 lg:gap-12 xl:max-w-[96rem] xl:gap-16"
    >
        <!-- Left Hero & Brand Showcase (Desktop) -->
        <div
            class="relative hidden flex-col justify-center space-y-8 lg:flex lg:w-5/12"
        >
            <!-- Hero Content & Copy -->
            <div class="relative z-10 max-w-xl space-y-6">
                <!-- Brand Logo with Rounded White Background -->
                <div>
                    <a
                        routerLink="/"
                        class="inline-flex items-center justify-center rounded-2xl border border-slate-200/90 bg-white p-3 shadow-xs transition-all duration-200 hover:scale-[1.02] hover:border-slate-300 hover:shadow-sm"
                    >
                        <img
                            src="assets/images/cjc.svg"
                            alt="Chakrijibi Club Logo"
                            class="h-11 w-auto object-contain md:h-12"
                        />
                    </a>
                </div>

                <!-- Tag / Badge -->
                <div
                    class="inline-flex items-center gap-2 rounded-full border border-sky-200/80 bg-sky-50 px-3.5 py-1.5 text-xs font-semibold text-[#1587e8] shadow-xs"
                >
                    <ng-icon
                        name="lucideKeyRound"
                        class="h-3.5 w-3.5 text-[#1587e8]"
                    />
                    <span>Corporate Benefit Ecosystem</span>
                </div>

                <h1
                    class="font-secondary text-3xl leading-snug font-extrabold tracking-tight text-[#0f172a] sm:text-4xl"
                >
                    Fast & secure <br />
                    <span
                        class="bg-gradient-to-r from-[#0284c7] to-[#0f6ebd] bg-clip-text text-transparent"
                        >account recovery</span
                    >
                    in seconds.
                </h1>

                <p class="text-sm leading-relaxed text-slate-600 sm:text-base">
                    Forgot your password? No problem. Simply submit your
                    registered corporate email address, and we'll instantly
                    email you a secure link to reset your credentials.
                </p>

                <!-- Feature Highlight Cards (Light theme) -->
                <div class="grid grid-cols-1 gap-3 pt-2 sm:grid-cols-3">
                    <div
                        class="rounded-2xl border border-slate-200/90 bg-white/85 p-3.5 shadow-xs backdrop-blur-xs transition-all hover:bg-white hover:shadow-sm"
                    >
                        <div
                            class="mb-2 flex h-8 w-8 items-center justify-center rounded-xl bg-sky-50 text-[#1587e8]"
                        >
                            <ng-icon name="lucideKeyRound" class="h-4 w-4" />
                        </div>
                        <h3 class="text-xs font-bold text-[#0f172a]">
                            Encrypted Link
                        </h3>
                        <p
                            class="mt-0.5 text-[11px] leading-tight text-slate-500"
                        >
                            Single-use reset token
                        </p>
                    </div>

                    <div
                        class="rounded-2xl border border-slate-200/90 bg-white/85 p-3.5 shadow-xs backdrop-blur-xs transition-all hover:bg-white hover:shadow-sm"
                    >
                        <div
                            class="mb-2 flex h-8 w-8 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600"
                        >
                            <ng-icon
                                name="lucideCheckCircle2"
                                class="h-4 w-4"
                            />
                        </div>
                        <h3 class="text-xs font-bold text-[#0f172a]">
                            Fast Delivery
                        </h3>
                        <p
                            class="mt-0.5 text-[11px] leading-tight text-slate-500"
                        >
                            Immediate inbox link
                        </p>
                    </div>

                    <div
                        class="rounded-2xl border border-slate-200/90 bg-white/85 p-3.5 shadow-xs backdrop-blur-xs transition-all hover:bg-white hover:shadow-sm"
                    >
                        <div
                            class="mb-2 flex h-8 w-8 items-center justify-center rounded-xl bg-blue-50 text-blue-600"
                        >
                            <ng-icon name="lucideShieldCheck" class="h-4 w-4" />
                        </div>
                        <h3 class="text-xs font-bold text-[#0f172a]">
                            24/7 Safety
                        </h3>
                        <p
                            class="mt-0.5 text-[11px] leading-tight text-slate-500"
                        >
                            Account protection
                        </p>
                    </div>
                </div>
            </div>

            <!-- Trust Footer -->
            <div
                class="flex items-center justify-between border-t border-slate-200/80 pt-5 text-xs text-slate-400"
            >
                <p>&copy; 2026 ChakrijibiClub. All rights reserved.</p>
                <div class="flex items-center gap-1.5 text-slate-500">
                    <ng-icon
                        name="lucideShieldCheck"
                        class="h-4 w-4 text-emerald-600"
                    />
                    <span>256-Bit SSL Encrypted</span>
                </div>
            </div>
        </div>

        <!-- Right Form Section -->
        <div
            class="relative flex w-full flex-col items-center justify-center lg:w-7/12"
        >
            <!-- Mobile Logo Bar -->
            <div class="flex w-full items-center pb-4 lg:hidden">
                <a
                    routerLink="/"
                    class="inline-flex items-center justify-center rounded-xl border border-slate-200/90 bg-white p-2 shadow-xs transition-transform hover:scale-[1.02]"
                >
                    <img
                        src="assets/images/cjc.svg"
                        alt="Chakrijibi Club Logo"
                        class="h-8 w-auto object-contain"
                    />
                </a>
            </div>

            <!-- Centered Forgot Password Card with INCREASED WIDTH (max-w-xl) -->
            <div class="mx-auto my-auto w-full max-w-xl py-6">
                <div
                    class="relative overflow-hidden rounded-3xl border border-slate-200/90 bg-white p-8 shadow-xl shadow-slate-200/60 sm:p-10 md:p-12"
                >
                    <!-- Top Accent Line -->
                    <div
                        class="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-b from-[#1587e8] to-[#0f6ebd] shadow-[0_4px_14px_0_rgb(21,135,232,0.39)] ring-1 ring-white/20 transition-all duration-200 ring-inset hover:shadow-[0_6px_20px_rgba(21,135,232,0.23)] hover:brightness-110 active:scale-[0.98]"
                    ></div>

                    @if (forgotPasswordFormService.submitted()) {
                        <!-- Success Confirmation State -->
                        <div class="space-y-6 text-center">
                            <div
                                class="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-emerald-50 text-emerald-500 ring-8 ring-emerald-500/10"
                            >
                                <ng-icon
                                    name="lucideCheckCircle2"
                                    class="h-10 w-10 text-emerald-500"
                                />
                            </div>

                            <div class="space-y-2">
                                <h2
                                    class="font-secondary text-2xl font-bold tracking-tight text-[#0f172a]"
                                >
                                    Reset link sent!
                                </h2>
                                <p
                                    class="text-sm leading-relaxed text-slate-500"
                                >
                                    We've sent password recovery instructions
                                    to:
                                </p>
                                <div
                                    class="mx-auto max-w-sm rounded-xl border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-semibold break-all text-slate-800"
                                >
                                    {{ forgotPasswordFormService.email?.value }}
                                </div>
                                <p class="text-xs text-slate-400">
                                    Please check your inbox and spam folder. The
                                    link expires in 30 minutes.
                                </p>
                            </div>

                            <div class="space-y-3 pt-2">
                                <a
                                    routerLink="/login"
                                    class="hover: flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-gradient-to-b from-[#1587e8] to-[#0f6ebd] py-3.5 text-sm font-semibold text-white shadow-[0_4px_14px_0_rgb(21,135,232,0.39)] ring-1 ring-white/20 transition-all duration-200 ring-inset hover:shadow-[0_6px_20px_rgba(21,135,232,0.23)] hover:brightness-110 active:scale-[0.98]"
                                >
                                    <ng-icon
                                        name="lucideArrowLeft"
                                        class="h-4 w-4"
                                    />
                                    <span>Back to Sign In</span>
                                </a>

                                <div
                                    class="flex items-center justify-center gap-4 pt-1 text-xs"
                                >
                                    <button
                                        type="button"
                                        (click)="resend()"
                                        class="inline-flex cursor-pointer items-center gap-1 font-semibold text-[#1587e8] transition hover:text-[#0f6ebd] hover:underline"
                                    >
                                        <ng-icon
                                            name="lucideRefreshCw"
                                            class="h-3.5 w-3.5"
                                        />
                                        <span>Resend email</span>
                                    </button>
                                    <span class="text-slate-300">•</span>
                                    <button
                                        type="button"
                                        (click)="resetForm()"
                                        class="cursor-pointer font-medium text-slate-500 transition hover:text-slate-700 hover:underline"
                                    >
                                        Try another email
                                    </button>
                                </div>
                            </div>
                        </div>
                    } @else {
                        <!-- Email Form State -->
                        <div class="mb-8 space-y-2 text-left">
                            <h2
                                class="font-secondary text-2xl font-bold tracking-tight text-[#0f172a] sm:text-3xl"
                            >
                                Forgot Password
                            </h2>
                            <p class="text-sm text-slate-500">
                                Enter your corporate email and we'll send you
                                reset instructions
                            </p>
                        </div>

                        <form
                            [formGroup]="forgotPasswordFormService.form"
                            (ngSubmit)="onSubmit()"
                            class="space-y-5"
                        >
                            <!-- Email Input -->
                            <div class="space-y-1.5">
                                <label
                                    for="forgot-email"
                                    class="block text-xs font-semibold tracking-wide text-slate-700 uppercase"
                                >
                                    Email Address
                                    <span class="text-red-500">*</span>
                                </label>
                                <div class="relative flex items-center">
                                    <span
                                        class="pointer-events-none absolute left-3.5 text-slate-400"
                                    >
                                        <ng-icon
                                            name="lucideMail"
                                            class="h-5 w-5"
                                        />
                                    </span>
                                    <input
                                        id="forgot-email"
                                        type="email"
                                        placeholder="name@company.com"
                                        formControlName="email"
                                        autocomplete="email"
                                        class="w-full rounded-xl border border-slate-200 bg-slate-50/70 py-3 pr-4 pl-11 text-sm text-slate-900 transition-all outline-none placeholder:text-slate-400 hover:border-slate-300 focus:border-[#1587e8] focus:bg-white focus:ring-4 focus:ring-[#1587e8]/10"
                                    />
                                </div>
                                @if (
                                    forgotPasswordFormService.email?.invalid &&
                                    forgotPasswordFormService.email?.touched
                                ) {
                                    <p class="text-xs font-medium text-red-600">
                                        Please enter a valid corporate email
                                        address.
                                    </p>
                                }
                            </div>

                            <!-- Submit Button -->
                            <button
                                type="submit"
                                [disabled]="
                                    forgotPasswordFormService.isSubmitting()
                                "
                                class="hover: mt-2 flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-gradient-to-b from-[#1587e8] to-[#0f6ebd] py-3.5 text-sm font-semibold text-white shadow-[0_4px_14px_0_rgb(21,135,232,0.39)] ring-1 ring-white/20 transition-all duration-200 ring-inset hover:shadow-[0_6px_20px_rgba(21,135,232,0.23)] hover:brightness-110 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60"
                            >
                                @if (forgotPasswordFormService.isSubmitting()) {
                                    <svg
                                        class="h-4 w-4 animate-spin text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            class="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            stroke-width="4"
                                        ></circle>
                                        <path
                                            class="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        ></path>
                                    </svg>
                                    <span>Sending link...</span>
                                } @else {
                                    <span>Send Reset Link</span>
                                    <ng-icon
                                        name="lucideArrowRight"
                                        class="h-4 w-4 transition-transform group-hover:translate-x-0.5"
                                    />
                                }
                            </button>
                        </form>
                    }
                </div>

                <!-- Footer Return Link -->
                <p class="mt-8 text-center text-sm text-slate-500">
                    Remember your password?
                    <a
                        routerLink="/login"
                        class="font-semibold text-[#1587e8] transition-colors hover:text-[#0f6ebd] hover:underline"
                    >
                        Back to log in
                    </a>
                </p>
            </div>

            <!-- Bottom Security Note -->
            <div class="pt-4 text-center text-xs text-slate-400">
                Protected by corporate SSO and security protocols.
            </div>
        </div>
    </div>
</div>
